var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41797 11.1129L0.00125456 15.8016V6.22617L7.41797 11.1129Z",
    fill: "#66789C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.22617V15.8016L14.5832 11.1129L22 6.22617Z",
    fill: "#66789C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37721 3.4375H20.6272C21.3133 3.4375 21.8578 3.949 21.9609 4.60763L11.0022 11.8277L0.0434284 4.60763C0.146534 3.949 0.691034 3.4375 1.37721 3.4375Z",
    fill: "#66789C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67731 11.9431L10.6229 13.2246C10.7384 13.3002 10.869 13.3374 11.001 13.3374C11.133 13.3374 11.2636 13.3002 11.3791 13.2246L13.3248 11.9417L21.957 17.4019C21.8512 18.055 21.3094 18.5624 20.626 18.5624H1.37603C0.692635 18.5624 0.150921 18.055 0.0450268 17.4019L8.67731 11.9431Z",
    fill: "#66789C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7d240b16b94169bdee41dc294a2cacf7.svg";
export { ForwardRef as ReactComponent };